// src/store/thunks/sixCatalog/fetchSixCatalog.ts

import type { FetchSixesCatalogParams } from '@/types/SixCatalogDTOs';
import type { MappedSixesCatalogResponse } from '@/store/mappers/sixCatalog';
import { mapSixesCatalogPayloadDTOToResponse } from '@/store/mappers/sixCatalog';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';
import { initializeP2PStacksForCatalog } from '@/store/thunks/sixCatalog/initializeP2PStacksForCatalog';
import { facilitateFileKeys } from '@/store/thunks/fileKey/facilitateFileKeysThunk';

export const fetchSixCatalogThunk = createAppAsyncThunk<
  MappedSixesCatalogResponse,
  FetchSixesCatalogParams | undefined
>(
  'catalog/fetchSixes',
  withLoader(async (params, { dispatch, extra, getState }) => {
    const { filters, search, sortField, sortDirection } = getState().sixCatalog;

    const apiResponse = await extra.sixCatalogService.fetchSixes({
      filters,
      search,
      sortField,
      sortDirection,
      ...params,
    });
    const mappedResponse = mapSixesCatalogPayloadDTOToResponse(apiResponse);

    initializeP2PStacksForCatalog(dispatch, mappedResponse.sixes);

    if (getState().user.user?.id != null) {
      void dispatch(facilitateFileKeys());
    }

    return mappedResponse;
  })
);
